import React from "react";
import "../styles/ServiceCostCalculator.css";

const ServiceCostCalculator = () => {
  return (
    <div className="service-page coming-soon-page">
      <div className="coming-soon-container">
        <h1>🚧 Coming Soon</h1>
        <p>
          Our Car Service Cost Calculator is currently under development.
        </p>
        <p>
          We’re working hard to bring you accurate service cost estimates for
          your car across multiple cities.
        </p>

        <div className="coming-soon-cities">
          <span>📍 Indore</span>
          <span>📍 Bhopal</span>
          <span>📍 Ujjain</span>
          <span>📍 Dewas</span>
          <span>📍 Mhow</span>
          <span>📍 Pithampur</span>
        </div>

        {/*<button className="notify-btn">
          Notify Me When Live
        </button>*/}
      </div>
    </div>
  );
};

export default ServiceCostCalculator;